import React from "react";
import { User } from "../../types/user";
import "../UserBar.scss";

interface UserIconProps {
  user: User;
  selected?: boolean;
  onClick?: () => void;
  size?: "default" | "small";
}

const UserIcon: React.FC<UserIconProps> = ({ user, selected = false, onClick, size = "default" }) => {
  return (
    <div
      className={`user-icon ${selected ? "selected" : ""} ${size}`}
      onClick={onClick}
    >
      {user.name.charAt(0).toUpperCase()}{user.name.charAt(1)?.toLowerCase()}
    </div>
  );
};

export default UserIcon;
